import store from './store'
import router from './router.js'

export default {
  store,
  router,
}
